import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet, ViewStyle } from 'react-native';

import ActionButton from 'components/action-button';
import { Box, BoxProps } from 'components/ui';
import { layout } from 'styles/constants';

type FixedCallToActionProps = BoxProps & {
  paddingBottom?: number;
};

export const FixedCallToAction = ({ paddingBottom, style, ...props }: FixedCallToActionProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.fixedCallToAction, paddingBottom !== undefined && { paddingBottom }, style],
  });

export const FixedActionButton = makeUclComponent(ActionButton).withConfig({
  width: '$80',
  marginY: '$4',
  paddingX: '$1',
});

const styles = StyleSheet.create({
  fixedCallToAction: {
    alignItems: 'center',
    bottom: 0,
    justifyContent: 'center',
    position: 'fixed' as ViewStyle['position'],
    width: layout.full,
  },
});
